import { PracticeMappingHandler } from '../../../mappings/practices';

export class OasisPracticeMappingHandler extends PracticeMappingHandler {}
